import PropTypes from 'prop-types';
//import clsx from 'clsx';

import Phone from '../../../images/map-phone.inline.svg';
//import Clock from '../../../images/clock.inline.svg';
import Pin from '../../../images/pin.inline.svg';

const Location = ({ place, cta }) => {
	const { name, street, city, state, postal, phone1, description, url } = place || {};

	return (
		<article className="location-listing__item">
			<h3 className="location-listing__title">{name}</h3>
			<a
				className="btn btn--secondary location-listing__btn"
				target="_blank"
				rel="noreferrer"
				href={`${process.env.GATSBY_MAGENTO_PROD_BASE}/${url}`}
			>
				{cta.title}
			</a>
			<div className="location-listing__block">
				<h3 className="location-listing__heading">
					<Pin /> Address:
				</h3>
				<p className="location-listing__copy">
					{street}
					<br />
					{city}, {state} {postal}
				</p>
			</div>
			{phone1 && (
				<div className="location-listing__block">
					<h3 className="location-listing__heading">
						<Phone /> Phone:
					</h3>
					<p className="location-listing__copy">{phone1}</p>
				</div>
			)}
			{/* <div className="location-listing__block">
				<h3 className="location-listing__heading">
					<Clock /> Hours:
				</h3>
				<div className="location-listing__hours">
					{times.map((time, index) => (
						<p
							key={index}
							className="location-listing__copy location-listing__copy--hours"
						>
							{time}
						</p>
					))}
				</div>
			</div> */}
			<div
				className="location-listing__description"
				dangerouslySetInnerHTML={{ __html: description }}
			/>
			<a
				className="btn btn--secondary location-listing__btn location-listing__btn--desktop"
				target="_blank"
				rel="noreferrer"
				href={`${process.env.GATSBY_MAGENTO_PROD_BASE}/${url}`}
			>
				{cta.title}
			</a>
		</article>
	);
};

Location.propTypes = {
	place: PropTypes.shape({
		name: PropTypes.string,
		street: PropTypes.string,
		city: PropTypes.string,
		postal: PropTypes.string,
		state: PropTypes.string,
		country: PropTypes.string,
		description: PropTypes.string,
		url: PropTypes.string,
		phone1: PropTypes.string,
		time: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}).isRequired,
	show: PropTypes.bool,
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	}).isRequired,
};

export default Location;
